<template>
  <div>
    <ModalGroupSetHost v-if="hasGroupId" :groupId="groupId" :groupHost="groupHost" />
    <ModalGroupRemoveHost v-if="hasGroupId" :groupId="groupId" :groupHost="groupHost" />
    <ModalConfirmRemoveGroup v-if="hasGroupId" :groupId="groupId" />
    <ModalAppointmentVisitorEdit isAdmin />
    <ModalAppointmentRemoveFromGroup v-if="groupId" @refreshMap="refreshMap" :appointment="appointment" :groupId="groupId" />
    <ModalAddAppointmentToGroup v-if="hasSelectedMarkers" @refreshMap="refreshMap" :appointments="markers" :selectedAppointments="selectedAppointments" />

    <ModalUpdateAdditionalInfo v-if="appointment" @refreshMap="refreshMap" :additional-data="additionalData" />
    <ModalUpdateAdditionalInfoConfirmToClose />

    <AdminAppointmentChangeKeyLocation />
    <AdminAppointmentChangeStatus />
    <AdminAppointmentQuoteReopen />
    <AdminAppointmentChangeDate />
    <AdminAppointmentAddHost />
    <AdminAppointmentChangeHost />
    <AdminAppointmentChangeType />
    <AppointmentReschedule isAdmin />
    <AppointmentCancel isAdmin />
    <AppointmentUpdateObservations />

    <ModalConfirmAppointmentManually @refreshMap="refreshMap" :appointment="appointment" />
    <ModalBulkReschedule @refreshMap="refreshMap" :selectedAppointments="selectedAppointments" :groupId="groupId" />
    <ModalBulkCancel @refreshMap="refreshMap" :selectedAppointments="selectedAppointments" :groupId="groupId" :category="category" />
    <ModalBulkSendConfirmationEmail @refreshMap="refreshMap" :selectedAppointments="selectedAppointments" :groupId="groupId" />
    <ModalBulkChangeAppointmentStatus @refreshMap="refreshMap" :selectedAppointments="selectedAppointments" :groupId="groupId" />
  </div>
</template>

<script>
import AppointmentCancel from '@/components/appointment/AppointmentCancel'
import AppointmentReschedule from '@/components/appointment/AppointmentReschedule'

import AdminAppointmentAddHost from '@/components/appointment/AdminAppointmentAddHost'
import AdminAppointmentChangeDate from '@/components/appointment/AdminAppointmentChangeDate'
import AdminAppointmentChangeHost from '@/components/appointment/AdminAppointmentChangeHost'
import AdminAppointmentChangeType from '@/components/appointment/AdminAppointmentChangeType'
import AdminAppointmentQuoteReopen from '@/components/appointment/AdminAppointmentQuoteReopen'
import AdminAppointmentChangeStatus from '@/components/appointment/AdminAppointmentChangeStatus'
import AdminAppointmentChangeKeyLocation from '@/components/appointment/AdminAppointmentChangeKeyLocation'

import ModalGroupSetHost from '@/components/appointment/modals/ModalGroupSetHost'
import ModalGroupRemoveHost from '@/components/appointment/modals/ModalGroupRemoveHost'
import ModalConfirmRemoveGroup from '@/components/appointment/modals/ModalConfirmRemoveGroup'
import ModalAddAppointmentToGroup from '@/components/appointment/modals/ModalAddAppointmentToGroup'
import ModalAppointmentVisitorEdit from '@/components/appointment/modals/ModalAppointmentVisitorEdit'
import ModalAppointmentRemoveFromGroup from '@/components/appointment/modals/ModalAppointmentRemoveFromGroup'

import ModalBulkCancel from '@/components/appointment/modals/ModalBulkCancel'
import ModalBulkReschedule from '@/components/appointment/modals/ModalBulkReschedule'
import ModalConfirmAppointmentManually from '@/components/appointment/modals/ModalConfirmAppointmentManually'
import ModalBulkSendConfirmationEmail from '@/components/appointment/modals/ModalBulkSendConfirmationEmail'
import ModalBulkChangeAppointmentStatus from '@/components/appointment/modals/ModalBulkChangeAppointmentStatus'

import ModalUpdateAdditionalInfo from '@/components/appointment/modals/ModalUpdateAdditionalInfo'
import ModalUpdateAdditionalInfoConfirmToClose from '@/components/appointment/modals/ModalUpdateAdditionalInfoConfirmToClose'
import AppointmentUpdateObservations from '@/components/appointment/AppointmentUpdateObservations'

export default {
  name: 'SelectedMarkersModals',

  props: {
    hasGroupId: {
      type: Boolean,
      required: false,
    },

    groupId: {
      type: String,
      required: false,
    },

    groupHost: {
      type: Object,
      required: false,
    },

    markers: {
      type: Array,
      required: false,
    },

    appointment: {
      type: Object,
      required: false,
    },

    hasSelectedMarkers: {
      type: Boolean,
      required: false,
    },

    selectedAppointments: {
      type: Array,
      required: false,
    },

    category: {
      type: String,
      required: false,
    },
  },

  components: {
    ModalGroupSetHost,
    ModalGroupRemoveHost,
    ModalConfirmRemoveGroup,
    ModalAddAppointmentToGroup,

    AppointmentCancel,
    AppointmentReschedule,
    AdminAppointmentAddHost,
    AdminAppointmentChangeDate,
    AdminAppointmentChangeHost,
    AdminAppointmentChangeType,
    AdminAppointmentQuoteReopen,
    AdminAppointmentChangeStatus,
    AdminAppointmentChangeKeyLocation,
    ModalAppointmentRemoveFromGroup,
    ModalAppointmentVisitorEdit,

    ModalUpdateAdditionalInfo,
    ModalUpdateAdditionalInfoConfirmToClose,

    ModalConfirmAppointmentManually,
    ModalBulkReschedule,
    ModalBulkCancel,
    ModalBulkSendConfirmationEmail,
    AppointmentUpdateObservations,
    ModalBulkChangeAppointmentStatus,
  },

  computed: {
    additionalData() {
      return this.appointment?.additional_data ?? []
    },
  },

  methods: {
    refreshMap() {
      this.$emit('refreshMap')
    },
  },
}
</script>
